import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * External dependencies
 */
import React from 'react';
export default function (i18n) {
  function bindTranslate() {
    var translate = i18n.translate.bind(i18n);
    Object.defineProperty(translate, 'localeSlug', {
      get: i18n.getLocaleSlug.bind(i18n)
    });
    return translate;
  }

  return function useTranslate() {
    var _React$useState = React.useState(bindTranslate),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        translate = _React$useState2[0],
        setTranslate = _React$useState2[1];

    React.useEffect(function () {
      var onChange = function onChange() {
        return setTranslate(bindTranslate);
      };

      i18n.on('change', onChange);
      return function () {
        return i18n.off('change', onChange);
      };
    }, []);
    return translate;
  };
}